import { JSX } from 'react';
import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface Props {
  text: string | null;
  sx?: SxProps<Theme>;
}

export default function HelpText({ text, sx }: Props): JSX.Element | null {
  if (!text) {
    return null;
  }
  return (
    <Typography
      sx={{ fontSize: 14, color: 'text.secondary', lineHeight: 1.5, ...sx }}
    >
      {text}
    </Typography>
  );
}
